<template>
  <b-dropdown
    size="sm"
    variant="primary"
    title="Processed PPT files"
    :dropBottom="true"
    class="mr-2"
    :disabled="!files.length"
    :menu-class="['notification-box']"
  >
    <template slot="button-content">
      <i class="fa fa-bell"></i>
      PPT Files
      <b-badge variant="danger">{{ files.length }}</b-badge>
    </template>
    <b-dropdown-item-button
      v-for="file in files"
      :key="file.id"
      @click="openPresentation(file, true)"
    >
      {{ file.name }}
    </b-dropdown-item-button>
  </b-dropdown>
</template>

<script>
import { assign, cloneDeep } from "lodash";
import swal from "sweetalert";
import { PPT_PROCESSED } from "../../../constants/constants";

export default {
  name: "presentation-ppt-notification",
  data() {
    return {
      files: [],
      filesCopy: [],
      interval: null,
    };
  },
  mounted() {
    this.init();
  },
  beforeDestroy() {
    clearInterval(this.interval);
    this.interval = null;
  },
  methods: {
    init() {
      this.getPptFiles();
      this.interval = window.setInterval(() => {
        this.getPptFiles();
      }, 10000);
    },
    openPresentation(data, canOpen) {
      this.$api
        .notifyPresentationPptFilesFact([
          assign({}, data, {
            notified: true,
          }),
        ])
        .then(
          () => {
            this.files = this.files.filter((file) => file.id !== data.id);
            this.$emit("refresh");
            if (canOpen) {
              this.$emit("open-presentation", data);
            }
          },
          (error) => {
            this.$handleError(error);
          },
        );
    },
    getPptFiles() {
      this.$api
        .getPresentationPptFilesByFact({
          status: PPT_PROCESSED,
          isNotified: false,
        })
        .then(
          (response) => {
            if (!this.$handleResponse(response)) return;
            this.filesCopy = cloneDeep(this.files);
            this.files = response.data.payload || [];
            if (this.files.length > this.filesCopy.length && this.files.length) {
              const latest = this.files[this.files.length - 1];
              swal("PPT slide processing is complete. Click Continue to view slides.", {
                buttons: ["Cancel", "Continue"],
              }).then((result) => {
                this.openPresentation(latest, !!result);
              });
            }
          },
          (error) => {
            this.$handleError(error);
          },
        );
    },
  },
};
</script>
